"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LateDeliveryVoucher = void 0;
var _react = _interopRequireWildcard(require("react"));
var _getPrefixCls = require("../../utils/getPrefixCls");
var _clsx = _interopRequireDefault(require("clsx"));
var _RichText = require("../RichText");
var _voucherFrame = _interopRequireDefault(require("../../assets/images/voucher-frame.png"));
var _context = require("../ConfigProvider/context");
var _types = require("../../types");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var LateDeliveryVoucher = function LateDeliveryVoucher(props) {
  var title = props.title,
    issueDesc = props.issueDesc,
    vouchers = props.vouchers,
    disableBtn = props.disableBtn;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _getPrefixCls.getPrefixCls)('late-delivery-voucher')
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "head"
  }, /*#__PURE__*/_react.default.createElement("svg", {
    className: "logo",
    width: "12",
    height: "12",
    viewBox: "0 0 12 12",
    fill: "none"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.84155 8.41835C7.77543 8.96175 7.4448 9.39713 6.93283 9.6151C6.64784 9.73642 6.26584 9.80169 5.96303 9.78111C5.4921 9.76318 5.04946 9.64887 4.64166 9.44033C4.49323 9.36441 4.27559 9.21438 4.11152 9.0772C4.07414 9.04604 4.05488 9.0181 4.09087 8.96729C4.12918 8.90958 4.2809 8.68975 4.3048 8.65348C4.33704 8.60415 4.39002 8.60166 4.43857 8.63979C4.44527 8.64494 4.49458 8.68329 4.50452 8.69073C4.89715 8.99705 5.40347 9.2271 5.96615 9.24862C6.67578 9.23898 7.19063 8.92201 7.28254 8.43116C7.38382 7.89018 6.95348 7.42618 6.12466 7.16733C5.86121 7.08506 5.19878 6.82081 5.07643 6.74928C4.499 6.41185 4.23008 5.96923 4.26843 5.42436C4.32705 4.66922 5.02973 4.10342 5.92143 4.09965C6.34469 4.09881 6.74161 4.19232 7.09529 4.34079C7.22544 4.39545 7.4679 4.52565 7.55434 4.58999C7.61473 4.63417 7.61009 4.68363 7.58624 4.72193C7.55101 4.78057 7.44623 4.94413 7.404 5.01227C7.3732 5.05903 7.33506 5.0644 7.28086 5.03015C6.82481 4.72498 6.35582 4.62153 5.93361 4.61307C5.32445 4.62512 4.86512 4.98577 4.83494 5.48025C4.82697 5.92692 5.16755 6.25091 5.89054 6.49834C7.38319 6.97617 7.94868 7.53782 7.84155 8.41835ZM5.99973 0.656655C6.9659 0.656655 7.75346 1.57008 7.79033 2.71347H4.20912C4.24599 1.57008 5.03356 0.656655 5.99973 0.656655ZM9.66776 11.2465C10.1781 11.2327 10.5915 10.8192 10.6352 10.3066L10.6384 10.2447L10.9997 2.93963V2.93954C10.9999 2.93587 11 2.93219 11 2.92847C11 2.80972 10.9041 2.7135 10.7857 2.7135H10.7824H8.46448C8.4075 1.2038 7.32577 0 5.99968 0C4.6736 0 3.59186 1.2038 3.53488 2.7135H1.21034V2.71355C1.09381 2.71566 1 2.81107 1 2.92847C1 2.93409 1.00017 2.93963 1.00063 2.94512L1.00059 2.94517L1.33033 10.2215L1.33526 10.3128C1.38558 10.8191 1.75443 11.2269 2.25604 11.2457H2.25621L9.6308 11.2468L9.66776 11.2465Z",
    fill: "#EE4D2D"
  })), /*#__PURE__*/_react.default.createElement("p", null, title)), /*#__PURE__*/_react.default.createElement(_RichText.RichText, {
    content: issueDesc
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "content"
  }, vouchers.map(function (voucher) {
    var _ref = voucher || {},
      voucherParams = _ref.voucherParams;
    return /*#__PURE__*/_react.default.createElement(Voucher, {
      key: voucherParams.voucherCode,
      voucherInfo: voucher,
      disableBtn: disableBtn
    });
  })));
};
exports.LateDeliveryVoucher = LateDeliveryVoucher;
var Voucher = function Voucher(props) {
  var voucherInfo = props.voucherInfo,
    disableBtn = props.disableBtn;
  var context = (0, _react.useContext)(_context.ConfigContext);
  var _ref2 = voucherInfo || {},
    voucherParams = _ref2.voucherParams;
  var hanldeUse = function hanldeUse() {
    var _context$eventEmitter, _context$eventEmitter2;
    if (voucherInfo !== null && voucherInfo !== void 0 && voucherInfo.isClaimed || disableBtn) {
      return;
    }
    context === null || context === void 0 ? void 0 : (_context$eventEmitter = context.eventEmitter) === null || _context$eventEmitter === void 0 ? void 0 : (_context$eventEmitter2 = _context$eventEmitter.emit) === null || _context$eventEmitter2 === void 0 ? void 0 : _context$eventEmitter2.call(_context$eventEmitter, _types.ButtonEvents.Redirection, {
      text: '',
      action: {
        url_info: {
          url: 'voucher_pages',
          uri_extra: {
            promotionid: voucherParams === null || voucherParams === void 0 ? void 0 : voucherParams.promotionId,
            voucherCode: voucherParams === null || voucherParams === void 0 ? void 0 : voucherParams.voucherCode,
            signature: voucherParams === null || voucherParams === void 0 ? void 0 : voucherParams.signature
          }
        }
      }
    });
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _getPrefixCls.getPrefixCls)('voucher')
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: _voucherFrame.default,
    alt: "",
    className: "voucher-frame"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "voucher-info"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "voucher-name"
  }, voucherInfo === null || voucherInfo === void 0 ? void 0 : voucherInfo.name), /*#__PURE__*/_react.default.createElement("p", {
    className: "voucher-desc"
  }, voucherInfo === null || voucherInfo === void 0 ? void 0 : voucherInfo.desc), /*#__PURE__*/_react.default.createElement("p", {
    className: "voucher-valid"
  }, voucherInfo === null || voucherInfo === void 0 ? void 0 : voucherInfo.valid)), /*#__PURE__*/_react.default.createElement("svg", {
    className: "divider",
    width: "2",
    height: "68",
    viewBox: "0 0 2 68",
    fill: "none"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M1 0V68",
    stroke: "black",
    strokeOpacity: "0.15",
    strokeWidth: "0.5",
    strokeDasharray: "2 2"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "voucher-btn-wrapper"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)('use-btn', {
      gray: (voucherInfo === null || voucherInfo === void 0 ? void 0 : voucherInfo.isClaimed) || disableBtn
    }),
    onClick: hanldeUse
  }, voucherInfo === null || voucherInfo === void 0 ? void 0 : voucherInfo.btnText)));
};